const trackGoogleAnalytics = (event_name, event_params = {}) => {
  if (!window.gtag) return;

  window.gtag("event", event_name, event_params);
};

export { trackGoogleAnalytics };
